import { useState } from 'react';
import type { CSSProperties, SelectHTMLAttributes } from 'react';

export type SelectSize = 'sm' | 'md' | 'lg';

const alturas: Record<SelectSize, number> = { sm: 36, md: 42, lg: 60 };

export interface SelectOption {
    value: string;
    label: string;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'size' | 'value' | 'style'> {
    value?: string;
    onChange?: (value: string) => void;
    options?: SelectOption[];
    /** Texto da opção vazia. */
    placeholder?: string;
    size?: SelectSize;
    invalid?: boolean;
    /** Estilo do invólucro, não do <select>. */
    style?: CSSProperties;
}

export function Select({
    value, onChange, options = [], placeholder = 'Selecione', size = 'md',
    invalid = false, disabled = false, id, style, ...rest
}: SelectProps) {
    const [focus, setFocus] = useState(false);
    return (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%', ...style }}>
            <select
                id={id} value={value ?? ''} disabled={disabled}
                aria-invalid={invalid || undefined}
                onChange={(e) => onChange?.(e.target.value)}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                style={{
                    width: '100%', appearance: 'none', fontFamily: 'var(--font-ui)', fontSize: 14,
                    color: value ? 'var(--text-primary)' : 'var(--text-tertiary)',
                    background: disabled ? 'var(--surface-secondary)' : 'var(--surface)',
                    border: `1px solid ${invalid ? 'var(--danger)' : focus ? 'var(--border-focus)' : 'var(--border-strong)'}`,
                    borderRadius: 'var(--radius-input)', height: alturas[size] ?? alturas.md,
                    padding: '0 32px 0 12px', outline: 'none', boxShadow: focus ? 'var(--focus-ring)' : 'none',
                    transition: 'var(--transition-control)', cursor: disabled ? 'not-allowed' : 'pointer',
                }}
                {...rest}
            >
                <option value="">{placeholder}</option>
                {options.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                ))}
            </select>
            <span aria-hidden="true" style={{ position: 'absolute', right: 11, pointerEvents: 'none', color: 'var(--neutral-500)', fontSize: 10 }}>▾</span>
        </div>
    );
}
